export enum FaultDependencyEnum {
    Company = 'Company',
    Craft = 'Craft',
    Order = 'Order'
}